import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';


@Component({
  selector: 'app-dashboard-card-view',
  standalone: false,
  templateUrl: './dashboard-card-view.component.html',
  styleUrls: ['./dashboard-card-view.component.scss']
})
export class DashboardCardViewComponent implements OnInit {
  @Input() groupedByDeviceGroups: any;
  isDeviceInfoVisible: any = null;
//   groupedByDeviceGroups: any[];
  deviceList: any[];

  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {
    // this.dashboardService.getDeviceGroups().subscribe((data: any) => {
    //   this.groupedByDeviceGroups = data;
    // });
  }

  showDeviceInfo(item: any) {
    if (this.isDeviceInfoVisible === item) {
      this.isDeviceInfoVisible = null;
    } else {
      this.isDeviceInfoVisible = item;
    }
  }
}
